import { SVGProps } from "react"

const BuildingStepIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="1" y="1" width="48" height="48" rx="24" fill="#2768A3" />
    <rect x="1" y="1" width="48" height="48" rx="24" stroke="#2768A3" stroke-width="2" />
    <path
      d="M19.7 31H17.15C15.72 31 15 30.28 15 28.85V17.15C15 15.72 15.72 15 17.15 15H21.45C22.88 15 23.6 15.72 23.6 17.15V19"
      stroke="white"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.37 21.42V32.58C30.37 34.19 29.57 35 27.96 35H22.12C20.51 35 19.7 34.19 19.7 32.58V21.42C19.7 19.81 20.51 19 22.12 19H27.96C29.57 19 30.37 19.81 30.37 21.42Z"
      stroke="white"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.4 19V17.15C26.4 15.72 27.12 15 28.55 15H32.85C34.28 15 35 15.72 35 17.15V28.85C35 30.28 34.28 31 32.85 31H30.37"
      stroke="white"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23 24H27"
      stroke="white"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23 27H27"
      stroke="white"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25 35V32"
      stroke="white"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default BuildingStepIcon
